import { Component, Host, h, Prop, Listen, Element } from '@stencil/core';
import { handleButtonKeydown, handleLinkClick, handleLinkKeydown } from "../../utils/utils";

@Component({
  tag: 'me-chip',
  styleUrl: 'me-chip.scss',
  shadow: false,
})
export class MeChip {
  private static nextChipID = 1;
  private readonly chipID = MeChip.nextChipID++;

  @Element() host: HTMLMeChipElement;

  @Prop() theme = 'light';
  @Prop() variant = 'normal';
  @Prop() active: boolean = false;
  @Prop() searchFilterIcon: boolean = false;

  @Prop({ reflect: true }) href?: string;
  @Prop() target = '_self';

  @Prop() role: null | string | 'link' | 'button' = null;

  @Listen('keydown')
  handleKeyDown(event: KeyboardEvent) {
    if (this.role === 'button') {
      handleButtonKeydown(event, this.host);
    }
    else if (this.role === 'link') {
      handleLinkKeydown(event, this.host);
    }
  }

  @Listen('click')
  handleClick(event: MouseEvent) {
    if (this.role === 'link' && this.href) {
      handleLinkClick(this.href, this.target, event)
    }
  }

  render() {
    const classList = [
      'me-chip',
      `me-chip--${this.theme}`,
      `me-chip--${this.variant}`,
      this.role ? `me-chip--${this.role}` : null,
      this.active ? 'me-chip--active' : null,
    ].filter(c => !!c).join(' ');

    const labelID = `me-chip-label-${this.chipID}`;

    return (
      <Host
        class={classList}
        aria-labelledby={labelID}
        tabindex={this.role ? '0' : null}
      >
        <span id={labelID} class="me-chip__label">
          <slot />
        </span>
        <span class="me-chip__search-filter-icon">
          <i class="fa-solid fa-times"></i>
        </span>
      </Host>
    );
  }

}
